import { Tab, TabProps } from "@chakra-ui/react"

const FilterTab = (props: TabProps) => {
  return (
    <Tab
      w={"full"}
      fontSize={"sm"}
      p={2}
      mb={2}
      textAlign={"left"}
      justifyContent={"flex-start"}
      border={"none"}
      borderColor={"yellow.400"}
      borderStyle={"solid"}
      _selected={{
        bg: "yellow.50",
        color: "black",
      }}
      {...props}
    >
      {props.children}
    </Tab>
  )
}

export default FilterTab
